import React, { useContext } from 'react';
import { generatePath } from 'react-router-dom';
import { ROUTE_PERSONS_ENTITY_PERSON_MEDICAL } from 'routes/RouteList';
import Icon from 'components/icon/Icon';
import ConfirmMutationButton from './ConfirmMutationButton';
import messages from 'messages';
import {
  MUTATION_REMOVE_PERSON_INJURY,
  QUERY_GET_PERSON_MEDICALS
} from 'services/aws/injury-query';
import { StoreContext } from 'index';

const RemovePersonIssueButton = ({
  entityId,
  groupId,
  personIssueId,
  personId,
  children,
  ...props
}) => {
  const {
    routing: { push },
    authStore: {
      user: { rootEntityId }
    }
  } = useContext(StoreContext);
  return (
    <ConfirmMutationButton
      {...props}
      mutation={MUTATION_REMOVE_PERSON_INJURY}
      confirmTitle={messages.modalConfirmRemovePersonIssueTitle}
      confirmMessage={messages.modalConfirmRemovePersonIssueMessage}
      variables={{
        personInjuryId: personIssueId
      }}
      refetchQueries={[
        {
          query: QUERY_GET_PERSON_MEDICALS,
          variables: { entityId: rootEntityId, personId }
        }
      ]}
      update={(cache, { data: { archivePersonInjury } }) => {
        if (archivePersonInjury) {
          push(
            generatePath(ROUTE_PERSONS_ENTITY_PERSON_MEDICAL, {
              entityId,
              groupId,
              personId: personId
            })
          );
        }
      }}
    >
      <Icon id="delete" />
      {children}
    </ConfirmMutationButton>
  );
};

export default RemovePersonIssueButton;
